import * as Utils from './utils';

const body = document.body,
      nav = document.querySelector(".js-nav-container"),
      navExpanders = document.querySelectorAll('.js-nav-expander'),
      sectionExpanders = document.querySelectorAll('.js-expand-section'),
      searchCloseTriggers = document.querySelectorAll('.js-search-close'),
      searchIcon = document.querySelectorAll('.js-search-function'),
      menuToggles = document.querySelectorAll('.js-open-menu');

let lastScroll = 0;

function toggleSectionList() {
    body.classList.toggle("section-list-open");
}

function toggleExpandSection(e) {
  e.preventDefault();
  const trigger = e.target,
        container = Utils.getClosest(trigger, '.js-expand-container');
  container.classList.toggle('open');

}

function toggleMenu() {
    body.classList.toggle("menu-open");
}

export function checkScrollPosition() {
  let scroll = (Utils.getScrollTop() > 72) ? true : false;
  headerScrollMode(scroll);
}

function checkScrollDirection() {
  const currentScroll = window.pageYOffset;

  if (currentScroll > lastScroll && !nav.classList.contains("scroll-down")) {
    // down
    nav.classList.remove("scroll-up");
    nav.classList.add("scroll-down");
  } else if (currentScroll < lastScroll && nav.classList.contains("scroll-down")) {
    // up
    nav.classList.remove("scroll-down");
    nav.classList.add("scroll-up");
  }
  lastScroll = currentScroll;
}

function headerScrollMode(scroll) {
  body.classList[scroll == true ? 'add' : 'remove']('scroll');
  if (scroll == false) {
    body.classList.remove('section-list-open');
  }
}

function closeSearchInput(e) {

  e.preventDefault();

  const body = document.querySelector('body');

  body.classList.remove("search-active");

}

function doSearchFunction(e) {

  const body = document.querySelector('body'),
        input = document.querySelector('.js-search-input');

  // If search isn't active, open search and stop
  if (!body.classList.contains("search-active")) {
    e.preventDefault();

    body.classList.add("search-active");
    document.getElementById("search").focus();

    // If Nav is open (on tablet and above), close it
    if (body.classList.contains('nav-open') && window.matchMedia( '(min-width: 800px)' ).matches) {
      body.classList.remove('restrict-height','nav-open');
    }

    // If escape is pressed, close the search
    window.onkeydown = function( event ) {
    if ( event.keyCode == 27 ) {
        closeSearchInput();
      }
    };

    return;
  }

  // If search field is empty, stop form
  if(input.value.length == 0 || input.value == 'Search...') {
    e.preventDefault();
    return;
  }

}

navExpanders.forEach(el => {
    el.addEventListener('click', toggleSectionList);
});

sectionExpanders.forEach(el => {
    el.addEventListener('click', toggleExpandSection);
});

menuToggles.forEach(el => {
    el.addEventListener('click', toggleMenu);
});

searchCloseTriggers.forEach(el => {
    el.addEventListener('click', closeSearchInput);
});

searchIcon.forEach(el => {
    el.addEventListener('click', doSearchFunction);
});

window.addEventListener('scroll', () => {
  checkScrollPosition();
  checkScrollDirection();
});

checkScrollPosition();
